module.exports = __webpack_public_path__ + "img/leftTrapezoid.88b6704a.svg";